import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postPromotionRedemptionReapply } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { promotionsKeyFn, promotionsRedemptionKeyFn } from './rewards.keys';

interface ReapplyRequestBody extends Rewards.PromotionReapplyRedemptionRequest {
  uuid: string;
}

export function usePostPromotionRedemptionReapplyMutation(
  options?: UseMutationOptions<Rewards.PromotionRedemption, ReapplyRequestBody>
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ uuid, ...promotionReapplyRedemptionRequest }) =>
      postPromotionRedemptionReapply(uuid, promotionReapplyRedemptionRequest),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        const { uuid } = data;

        queryClient.setQueryData(promotionsRedemptionKeyFn(uuid), data);

        queryClient.invalidateQueries(promotionsKeyFn());

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
}
